import "../assets/index-6c47e88a.css";
import { t as a } from "../chunks/l10n-ef44019c.mjs";
import { G as s } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { n as u } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const r = {
  name: "NcSettingsInputText",
  props: {
    /**
     * label of the select group element
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * hint of the select group input
     */
    hint: {
      type: String,
      default: ""
    },
    /**
     * value of the select group input
     */
    value: {
      type: String,
      default: ""
    },
    /**
     * disabled state of the settings select group input
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * id attribute of the select group element
     */
    id: {
      type: String,
      default: () => "settings-input-text-" + s(),
      validator: (e) => e.trim() !== ""
    }
  },
  emits: [
    "update:value",
    "input",
    "submit",
    "change"
  ],
  data() {
    return {
      submitTranslated: a("Submit")
    };
  },
  computed: {
    /**
     * @return {string}
     */
    idSubmit() {
      return this.id + "-submit";
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e), this.$emit("update:value", e.target.value);
    },
    onSubmit(e) {
      this.disabled || this.$emit("submit", e);
    },
    onChange(e) {
      this.$emit("change", e);
    }
  }
};
var l = function() {
  var t = this, i = t._self._c;
  return i("form", { ref: "form", attrs: { disabled: t.disabled }, on: { submit: function(n) {
    return n.preventDefault(), n.stopPropagation(), t.onSubmit.apply(null, arguments);
  } } }, [i("div", { staticClass: "input-wrapper" }, [i("label", { staticClass: "action-input__label", attrs: { for: t.id } }, [t._v(t._s(t.label))]), i("input", { attrs: { id: t.id, type: "text", disabled: t.disabled }, domProps: { value: t.value }, on: { input: t.onInput, change: t.onChange } }), i("input", { staticClass: "action-input__submit", attrs: { id: t.idSubmit, type: "submit" }, domProps: { value: t.submitTranslated } }), t.hint ? i("p", { staticClass: "hint" }, [t._v(" " + t._s(t.hint) + " ")]) : t._e()])]);
}, o = [], p = /* @__PURE__ */ u(
  r,
  l,
  o,
  !1,
  null,
  "5b140fb6",
  null,
  null
);
const c = p.exports;
export {
  c as default
};
